/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconQuoteLeft from '@telus-uds/palette-koodo/build/rn/icons/QuoteLeft'
import PaletteIconQuoteRightArrow from '@telus-uds/palette-koodo/build/rn/icons/QuoteRightArrow'
const theme = {
  appearances: {
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'md', 'lg', 'xl' ] },
      tokens: {
        testimonialFontNameHeading: 'StagSans',
        testimonialFontSizeHeading: 32,
        testimonialFontWeightHeading: '700',
        testimonialLineHeightHeading: 1.25
      }
    }
  ],
  tokens: {
    additionalFontName: 'StagSans',
    additionalFontSize: 14,
    additionalFontWeight: '400',
    additionalLineHeight: 1.42857142857,
    authorFontName: 'StagSans',
    authorFontSize: 16,
    authorFontWeight: '600',
    authorLineHeight: 1.5,
    dividerBackgroundColor: '#c9c8c8',
    dividerBorder: 1,
    figcaptionGap: 12,
    icon: PaletteIconQuoteLeft,
    iconColor: '#c9c8c8',
    iconFr: PaletteIconQuoteRightArrow,
    imageSize: 48,
    quoteContainerGap: 4,
    testimonialContainerGap: 12,
    testimonialFontNameHeading: 'StagSans',
    testimonialFontNameLarge: 'StagSans',
    testimonialFontSizeHeading: 24,
    testimonialFontSizeLarge: 20,
    testimonialFontWeightHeading: '700',
    testimonialFontWeightLarge: '400',
    testimonialLineHeightHeading: 1.33333333333,
    testimonialLineHeightLarge: 1.4,
    textColor: '#000000'
  }
}
export default theme
